import {
  GET_NORM,
  GET_NORM_FAIL,
  GET_NORM_SUCCESS,
  GET_NORMS,
  GET_NORMS_FAIL,
  GET_NORMS_SUCCESS,
  ADD_NEW_NORM,
  ADD_NORM_SUCCESS,
  ADD_NORM_FAIL,
  UPDATE_NORM,
  UPDATE_NORM_SUCCESS,
  UPDATE_NORM_FAIL,
  DELETE_NORM,
  DELETE_NORM_SUCCESS,
  DELETE_NORM_FAIL,
  SET_STATE_NORM,
  UPDATE_NORM_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_NORM,
  payload: loading,
})

export const getNorms = ( params ) => ({
  type: GET_NORMS,
  payload: { params },
})

export const getNormsSuccess = (norms, totalPages, currentPage) => ({
  type: GET_NORMS_SUCCESS,
  payload: { norms:norms, total:totalPages, currentPage:currentPage}
})

export const getNormsFail = error => ({
  type: GET_NORMS_FAIL,
  payload: error,
})

export const addNewNorm = norm => ({
  type: ADD_NEW_NORM,
  payload: norm,
})

export const addNormSuccess = norm => ({
  type: ADD_NORM_SUCCESS,
  payload: norm,
})  

export const addNormFail = error => ({
  type: ADD_NORM_FAIL,
  payload: error,
})

export const updateNorm = norm => ({
  type: UPDATE_NORM,
  payload: norm,
})

export const updateNormStatus = norm => ({
  type: UPDATE_NORM_STATUS,
  payload: norm,
})

export const updateNormSuccess = norm => ({
  type: UPDATE_NORM_SUCCESS,
  payload: norm,
})

export const updateNormFail = error => ({
  type: UPDATE_NORM_FAIL,
  payload: error,
})

export const deleteNorm = norm => ({
  type: DELETE_NORM,
  payload: norm,
})

export const deleteNormSuccess = id => ({
  type: DELETE_NORM_SUCCESS,
  id,
})

export const deleteNormFail = error => ({
  type: DELETE_NORM_FAIL,
  payload: error,
})

export const getNorm = () => ({
  type: GET_NORM,
})

export const getNormSuccess = norm => ({
  type: GET_NORM_SUCCESS,
  payload: norm,
})

export const getNormFail = error => ({
  type: GET_NORM_FAIL,
  payload: error,
})
